/* eslint-disable @typescript-eslint/lines-between-class-members */
import { CreateCustomerParams } from '../interfaces/customer';
import {
  getDocumentFormat,
  getIdDocumentType,
  hasContactPoint,
} from '../utils';

type ContactPoint = {
  tipoMedioContacto?: string;
  principal?: string;
  numeroTelefono?: string;
  correo?: string;
  codigoTelefonoPais?: string;
};

class CreateCustomerParamsModel {
  nombres: string;
  apellidoPaterno: string;
  apellidoMaterno?: string;
  fechaNacimiento: string;
  genero: number;
  tipoDocumento: number;
  numeroDocumento: string;
  nacionalidad: number;
  consentimiento: boolean;
  medioContacto: ContactPoint[];

  constructor({
    firstName,
    lastName,
    secondLastName,
    birthDate = '',
    gender,
    documentType,
    numDocument,
    nacionality,
    phoneNumber,
    emailAddress,
    givesPersonalDataConsent,
  }: CreateCustomerParams) {
    this.nombres = firstName;
    this.apellidoPaterno = lastName;
    this.apellidoMaterno = secondLastName;
    this.fechaNacimiento = birthDate;
    this.nacionalidad = nacionality === 'PE' ? 1 : 2;
    this.genero = gender === 'M' ? 1 : 2;
    this.tipoDocumento = getIdDocumentType(documentType);
    this.numeroDocumento = getDocumentFormat(numDocument, documentType);
    this.consentimiento = givesPersonalDataConsent;
    this.medioContacto = hasContactPoint(phoneNumber, emailAddress);
  }
}

export default CreateCustomerParamsModel;
